import { useContext } from 'react';
import portalLink from '../utils/portalLinks';
import { getIcon } from '../icons/AppIcons';
import { ImpersonationContext } from '../components/impersonation-wrapper/ImpersonationWrapper';

const GENERAL = [
  {
    id: 'home',
    href: portalLink('home', ''),
    text: 'Home',
    icon: getIcon('Home'),
  },
  {
    id: 'moodle',
    href: 'https://learning.monash.edu',
    text: 'Moodle',
    icon: getIcon('Moodle'),
  },
  {
    id: 'wes',
    href: 'https://my.monash.edu.au/wes/',
    text: 'WES',
    icon: getIcon('WES'),
  },
  {
    id: 'email',
    href: 'https://mail.google.com/a/monash.edu',
    text: 'Gmail',
    icon: getIcon('Email'),
  },
  {
    id: 'calendar',
    href: 'https://www.google.com/calendar/',
    text: 'Calendar',
    icon: getIcon('Calendar'),
  },
  {
    id: 'drive',
    href: 'https://drive.google.com/drive',
    text: 'Drive',
    icon: getIcon('Drive'),
  },
  {
    id: 'allocate',
    href: 'https://www.monash.edu/students/admin/timetables/allocate/login',
    text: 'Allocate+',
    icon: getIcon('Allocate'),
  },
  {
    id: 'library',
    href: 'http://library.monash.edu/',
    text: 'Library',
    icon: getIcon('Library'),
  },
  {
    id: 'handbook',
    href: 'https://handbook.monash.edu/',
    text: 'Handbook',
    icon: getIcon('Handbook'),
  },
  {
    id: 'research',
    href: portalLink('links', 'research'),
    text: 'Research',
    icon: getIcon(),
  },
  {
    id: 'allLinks',
    href: portalLink('links', ''),
    text: 'More links',
  },
];

const COLLEGE = [
  {
    id: 'home',
    href: portalLink('home', ''),
    text: 'Home',
    icon: getIcon('Home'),
  },
  {
    id: 'moodle mc',
    href: 'https://lms.monashcollege.edu.au/',
    text: 'Moodle MC',
    icon: getIcon('Moodle'),
  },
  {
    id: 'connect',
    href: 'https://collegeconnect.monashcollege.edu.au/',
    text: 'College Connect',
    icon: getIcon('Default'),
  },

  {
    id: 'email',
    href: 'https://mail.google.com/a/monash.edu',
    text: 'Gmail',
    icon: getIcon('Email'),
  },
  {
    id: 'calendar',
    href: 'https://www.google.com/calendar/',
    text: 'Calendar',
    icon: getIcon('Calendar'),
  },
  {
    id: 'drive',
    href: 'https://drive.google.com/drive',
    text: 'Drive',
    icon: getIcon('Drive'),
  },
  {
    id: 'allocate',
    href: 'https://www.monash.edu/students/admin/timetables/allocate/login',
    text: 'Allocate+',
    icon: getIcon('Allocate'),
  },
  {
    id: 'library',
    href: 'https://www.monashcollege.edu.au/current-students/library',
    text: 'Library',
    icon: getIcon('Library'),
  },
  {
    id: 'wes',
    href: 'https://my.monash.edu.au/wes/',
    text: 'WES',
    icon: getIcon('WES'),
  },
  {
    id: 'college',
    href: 'https://www.monashcollege.edu.au/',
    text: 'Monash College',
    icon: getIcon('Handbook'),
  },
  {
    id: 'forms',
    href: 'https://www.monashcollege.edu.au/about-us/policies-procedures/forms',
    text: 'Forms',
    icon: getIcon('Action'),
  },
  {
    id: 'allLinks',
    href: portalLink('links', ''),
    text: 'More links',
  },
];

export const useAppLauncherItems = () => {
  const { currentUser } = useContext(ImpersonationContext) ?? {};

  const items = currentUser?.is?.MonashCollege ? COLLEGE : GENERAL;

  return { items };
};
